const Bus = (state) => state.Bus

export default {
  Bus
}
